export function profileSet(state, payload){
    state.currentProfile = payload;
    state.error = undefined;

    return state;
}
